import axios from 'axios';

const url = '/api/follows_lists/';

export const fetchAllLists = () => axios.get(url);
export const createList = (newList) => axios.post(url, newList);
export const deleteList = (id) => axios.delete(`${url}${id}`);
export const editList = (id, newList) => axios.put(`${url}${id}`, newList);
